import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — password field with a show/hide eye toggle.
 * Extra props are forwarded to the underlying <input>.
 */
export default function PasswordInput({ value, onChange, testid, placeholder, autoFocus, className = "", ...rest }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        data-testid={testid}
        className={`brut-input pr-10 ${className}`}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 border-2 border-[#2F343A] bg-white hover:bg-zinc-100"
        aria-label={visible ? "Hide password" : "Show password"}
        data-testid={testid ? `${testid}-toggle` : "password-visibility-toggle"}
      >
        {visible ? <EyeOff size={14} /> : <Eye size={14} />}
      </button>
    </div>
  );
}
